import React, { Component } from 'react'

export default class CrossIcon extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
    <path stroke="#666" stroke-linecap="round" strokeLinejoin="round" strokeWidth="1.6" d="M12.996 4.635l-8 8M4.996 4.635l8 8"/>
</svg>

        )
    }
}
